module.exports = __webpack_public_path__ + "static/media/desktop_GA-2100-1AER_03.96344dd5.jpg";